import { IndicadorImpuestosService } from '../../../services/indicador-impuestos/indicador-impuestos.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService } from 'angular5-toaster';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import 'rxjs/add/operator/map';
import { StorageService } from '../../../services/storage.service';
import { User } from '../../../models/user';

@Component({
  selector: 'app-add-modal',
  templateUrl: './add-modal.component.html',
  styleUrls: ['./add-modal.component.scss'],
  providers: [IndicadorImpuestosService]
})
export class IndicadoresImpuestosExtModalComponent implements OnInit {

  public user: User;
  loading: boolean = false;
  closeResult: string;
  titulo = '';
  btnText = '';
  row: any;
  flagEditar: boolean = false;
  indicador: string | null;
  descripcion: string | null;
  deducible: any;
  deducibles: any = [
    {
      text: this.translate.instant('texto.SiDeducible'),
      value: 'true'
    },
    {
      text: this.translate.instant('texto.NoDeducible'),
      value: 'false'
    }
  ];

  constructor(
    private storageService: StorageService,
    private indicadoresImpuestosService: IndicadorImpuestosService,
    public activeModal: NgbActiveModal,
    private toasterService: ToasterService,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.user = this.storageService.getCurrentUser();
   
    if (this.row) {
      this.flagEditar = true;
      this.indicador = this.row.indicador;
      this.descripcion = this.row.descripcion;
      this.deducible = String(this.row.deducible);
    }

    (this.flagEditar) ? this.titulo = this.translate.instant('texto.editarLabel') : this.titulo = this.translate.instant('texto.registrarLabel');
    (this.flagEditar) ? this.btnText = this.translate.instant('texto.editarLabel') : this.btnText = this.translate.instant('texto.registrarLabel');
  }

  closeModal() {
    this.activeModal.close('');
  }

  validarRegistro() {
    (this.flagEditar) ? this.editarIndicador() : this.guardarIndicador();
  }

  guardarIndicador() {
    let body = {"indicadorImpExt": 
      {
        deducible: this.deducible,
        descripcion: this.descripcion,
        indicador: this.indicador
      }
    }

    this.loading = true;
    this.indicadoresImpuestosService.postIndicadorDeImpuesto(body).subscribe(
      data => {;
        this.loading = false;
        let response = data.result;

        if (response.estatus === 'S') {
          this.toasterService.pop('success', '', response.mensaje);
          this.activeModal.close('success');
        } else {
          this.toasterService.pop('error', 'Error', response.mensaje);
        }
      },
      err => {
        this.loading = false;
        this.toasterService.pop('error', 'Error', err.message);
      },
    );
  }

  editarIndicador() {
    let body = {"indicadorImpExt": 
      {
        deducible: this.deducible,
        descripcion: this.descripcion,
        indicador: this.indicador
      }
    }

    this.loading = true;
    this.indicadoresImpuestosService.updateIndicadorDeImpuesto(body).subscribe(
      data => {;
        this.loading = false;
        let response = data.result;

        if (response.estatus === 'S') {
          this.toasterService.pop('success', '', response.mensaje);
          this.activeModal.close('success');
        } else {
          this.toasterService.pop('error', 'Error', response.mensaje);
        }
      },
      err => {
        this.loading = false;
        this.toasterService.pop('error', 'Error', err.message);
      },
    );
  }

}




// WEBPACK FOOTER //
// ./src/app/pages/indicadores-impuestos/add-modal/add-modal.component.ts